export default __webpack_public_path__ + "static/media/ic-unseen.a86ba08a.svg";